import React, { useState, useRef, Children } from 'react';
import { CaretDown, Check } from '@phosphor-icons/react';
import { CATEGORY_TREE } from '../../../lib/constants';
import { cn } from '../../../lib/utils';
import { FilterPanel } from './FilterPanel';
interface CategoryDropdownProps {
  selected: string[];
  onChange: (selected: string[]) => void;
  resultCount: number;
}
export function CategoryDropdown({
  selected,
  onChange,
  resultCount
}: CategoryDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const toggleCategory = (value: string, children?: {
    value: string;
  }[]) => {
    let newSelected = [...selected];
    if (children) {
      const allChildrenSelected = children.every(c => selected.includes(c.value));
      if (allChildrenSelected) {
        newSelected = newSelected.filter(s => !children.some(c => c.value === s));
      } else {
        children.forEach(c => {
          if (!newSelected.includes(c.value)) newSelected.push(c.value);
        });
      }
    } else {
      if (newSelected.includes(value)) {
        newSelected = newSelected.filter(s => s !== value);
      } else {
        newSelected.push(value);
      }
    }
    onChange(newSelected);
  };
  const getLabel = () => {
    if (selected.length === 0) return 'Toate categoriile';
    const apartamentNode = CATEGORY_TREE.find(c => c.value === 'apartament_bloc');
    const apartamentChildren = apartamentNode?.children || [];
    const selectedApartamentChildren = apartamentChildren.filter(c => selected.includes(c.value));
    const parts: string[] = [];
    if (selectedApartamentChildren.length > 0) {
      if (selectedApartamentChildren.length === apartamentChildren.length) {
        parts.push('Apartament');
      } else {
        parts.push(`Apartament · ${selectedApartamentChildren.map(c => c.label.replace('camere', 'cam').replace('cameră', 'cam')).join(', ')}`);
      }
    }
    if (selected.includes('casa_vila')) parts.push('Casă/Vilă');
    if (selected.includes('garsoniera')) parts.push('Garsonieră');
    return parts.join(', ');
  };
  const handleClear = () => onChange([]);
  return <div className="relative min-w-0 sm:flex-1" ref={ref} data-id="element-2360">
      <button type="button" onClick={() => setIsOpen(!isOpen)} className={cn('w-full h-10 px-4 rounded-xl border text-sm flex items-center justify-between gap-2 transition-colors cursor-pointer', selected.length > 0 ? 'bg-dark-2 border-lime-1 text-lime-1' : 'bg-dark-3 border-dark-4 text-light-2 hover:border-light-4')} data-id="element-2361">
        <span className="truncate min-w-0" data-id="element-2362">{getLabel()}</span>
        <CaretDown size={14} className={cn('shrink-0 transition-transform', isOpen && 'rotate-180')} data-id="element-2363" />
      </button>

      <FilterPanel isOpen={isOpen} onClose={() => setIsOpen(false)} title="Categorii" anchorRef={ref} desktopWidthClass="sm:w-64" resultCount={resultCount} secondaryAction={selected.length > 0 ? {
      label: 'Resetează',
      onClick: handleClear
    } : null} data-id="element-2364">
        <div className="p-2 space-y-1" data-id="element-2365">
          {CATEGORY_TREE.map(node => {
          const hasChildren = !!node.children;
          const childrenSelectedCount = hasChildren ? node.children!.filter(c => selected.includes(c.value)).length : 0;
          const allSelected = hasChildren ? childrenSelectedCount === node.children!.length : selected.includes(node.value);
          const indeterminate = hasChildren && childrenSelectedCount > 0 && !allSelected;
          return <div key={node.value} data-id="element-2366">
                <button type="button" onClick={() => toggleCategory(node.value, node.children)} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-dark-3 transition-colors text-left" data-id="element-2367">
                  <div className={cn('w-4 h-4 rounded border flex items-center justify-center shrink-0 transition-colors', allSelected ? 'bg-lime-1 border-lime-1 text-dark-1' : indeterminate ? 'bg-lime-1/20 border-lime-1 text-lime-1' : 'border-light-3')} data-id="element-2368">
                    {allSelected && <Check size={12} weight="bold" data-id="element-2369" />}
                    {indeterminate && <div className="w-2 h-0.5 bg-current rounded-full" data-id="element-2370" />}
                  </div>
                  <span className="text-sm text-light-1 font-medium" data-id="element-2371">
                    {node.label}
                  </span>
                </button>

                {hasChildren && <div className="ml-7 mt-1 space-y-1" data-id="element-2372">
                    {node.children!.map(child => {
                const isChildSelected = selected.includes(child.value);
                return <button key={child.value} type="button" onClick={() => toggleCategory(child.value)} className="w-full flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-dark-3 transition-colors text-left" data-id="element-2373">
                          <div className={cn('w-4 h-4 rounded border flex items-center justify-center shrink-0 transition-colors', isChildSelected ? 'bg-lime-1 border-lime-1 text-dark-1' : 'border-light-3')} data-id="element-2374">
                            {isChildSelected && <Check size={12} weight="bold" data-id="element-2375" />}
                          </div>
                          <span className="text-sm text-light-2" data-id="element-2376">
                            {child.label}
                          </span>
                        </button>;
              })}
                  </div>}
              </div>;
        })}
        </div>
      </FilterPanel>
    </div>;
}